const BRIDGE_COMPANY_KEY = 'bridge-company';

export function normalizeCompanyId(companyId: string): string {
    return companyId.trim().toLowerCase();
}

export function setBridgeCompany(companyId: string | null | undefined): void {
    if (!companyId) return;

    try {
        sessionStorage.setItem(BRIDGE_COMPANY_KEY, normalizeCompanyId(companyId));
    } catch {
        // Private mode / quota. Reads then fall back to the unkeyed slots.
    }
}

export function getBridgeCompany(): string | null {
    try {
        const stored = sessionStorage.getItem(BRIDGE_COMPANY_KEY);
        return stored === null || stored.length === 0 ? null : stored;
    } catch {
        return null;
    }
}

export function clearBridgeCompany(): void {
    try {
        sessionStorage.removeItem(BRIDGE_COMPANY_KEY);
    } catch {
        // Storage unavailable; nothing to remove.
    }
}

export function companyScopedKey(baseKey: string): string {
    const company = getBridgeCompany();
    return company === null ? baseKey : `${baseKey}:${company}`;
}
